module.exports = __webpack_public_path__ + "img/big.a72b4ee5.jpg";